import { Icon } from '@goodlok/react-sdk'
import { Input, Select, notify } from '@goodlok/ui'
import { useQueryClient } from '@tanstack/react-query'
import clsx from 'clsx'
import { Dispatch, FunctionComponent, SetStateAction, useEffect, useState } from 'react'
import { api } from '../utilities/api'
import { AdminPageData, useAdminPageData } from '../utilities/useAdminPageData'
import styles from './AdminAddToShift.module.sass'
import { getStaffName } from './AdminShiftTileSegment'

type AdminAddToShiftProps = {
	date: string
	assignableEmployees: NonNullable<
		NonNullable<AdminPageData['getVenue']>['employeeRoles'][number]['role']
	>['shiftsProfiles'][number]['staff'][]
	position?: NonNullable<
		NonNullable<ReturnType<typeof useAdminPageData>['data']>['getVenue']
	>['timetableDays'][number]['shiftGroups'][number]
	setAddEmployeeActive: Dispatch<SetStateAction<boolean>>
	updateData: () => Promise<void>
}

export const AdminAddToShift: FunctionComponent<AdminAddToShiftProps> = ({
	date,
	assignableEmployees,
	position,
	setAddEmployeeActive,
}) => {
	const [employeeId, setEmployeeId] = useState(assignableEmployees.at(0)?.shiftsProfile?.id)

	useEffect(() => {
		if (!assignableEmployees.find((item) => item?.shiftsProfile?.id === employeeId)) {
			setEmployeeId(assignableEmployees[0]?.shiftsProfile?.id)
		}
	}, [assignableEmployees, employeeId])
	const isDynamic = position?.position?.isDynamic
	const [startTime, setStartTime] = useState(position?.position?.start)
	const [endTime, setEndTime] = useState(position?.position?.end)

	const queryClient = useQueryClient()
	const addToShiftMutation = api.shifts.addToShift.useMutation({
		onSuccess: ({ ok, displayedError }) => {
			if (!ok) {
				notify(displayedError ?? 'Nepodařilo se přidat zaměstnance', 'error')
			}
			queryClient.invalidateQueries(['adminPageData'])
			setAddEmployeeActive(false)
		},
	})

	return (
		<div className={styles.wrapper}>
			<form
				onSubmit={async (event) => {
					event.preventDefault()

					if (!employeeId) {
						notify('Není vybrán zaměstnanec')
						return
					}
					if (!startTime || !endTime) {
						notify('Není vybrán čas')
						return
					}
					if (!position) {
						notify('Neznámá pozice', 'error')
						return
					}

					addToShiftMutation.mutate({
						employeeId,
						groupId: position?.id,
						startTime: startTime,
						endTime: endTime,
						date: date,
					})
				}}>
				<div className={styles.selectorWrapper}>
					<Select
						options={assignableEmployees.map((staff) => ({
							label: getStaffName(staff),
							value: staff?.shiftsProfile?.id,
						}))}
						onChange={(event) => {
							setEmployeeId(event.target.value)
						}}
					/>
					<button
						type="button"
						className={styles.exitButton}
						onClick={() => setAddEmployeeActive(false)}>
						<Icon name="cross" />
					</button>
				</div>
				<div className={clsx(!isDynamic && styles.hide, styles.timeInputWrapper)}>
					<Input
						type="time"
						min={position?.position?.start}
						max={endTime}
						onChange={(event) => setStartTime(event.target.value)}
						value={startTime}
						size="compact"
					/>
					<div className={styles.arrowWrapper}>
						<Icon name="arrowRight" />
					</div>
					<Input
						type="time"
						min={startTime}
						max={position?.position?.end}
						onChange={(event) => setEndTime(event.target.value)}
						value={endTime}
						size="compact"
					/>
				</div>
				<button type="submit" className={styles.submitButton}>
					ok
				</button>
			</form>
		</div>
	)
}
